import {Injectable} from '@angular/core';
import moment from 'moment';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {DatePickerViewModel} from '../models';

@Injectable({
  providedIn: 'root',
})
export class MomentService {
  private DATE_RANGE_SEPARATOR = ' - ';
  private DATE_SEPARATOR = '-';

  public momentToNgbDateStruct(date?: moment.Moment): NgbDateStruct | undefined {
    if (date) {
      return {
        day: date.date(),
        month: date.month() + 1,
        year: date.year(),
      };
    }
    return undefined;
  }

  /**
   * This is required, as moment adds a timezone to the date when its parsed.
   * Doing this multiple times in combination with the NgbDateStruct, can lead to
   * wrong dates.
   * The ds-datepicker implements moment and converts the date on its own.
   * The NgbDateStruct passed into it must not have been converted to a moment.Moment before.
   * See: https://issues.wdf.sap.corp/browse/DCP-4692
   *
   * @param date string in format YYYY-MM-DD
   */
  public stringToNgbDateStruct(date: string): NgbDateStruct {
    const d: string[] = date.split(this.DATE_SEPARATOR);
    return {
      day: parseInt(d[2], 10),
      month: parseInt(d[1], 10),
      year: parseInt(d[0], 10),
    };
  }

  public ngbDateToMoment(date: NgbDateStruct): moment.Moment {
    return moment({
      year: date.year,
      month: date.month - 1,
      date: date.day,
    });
  }

  getStartDateRange(entryFieldMask?: string): DatePickerViewModel | undefined {
    if (entryFieldMask) {
      const dateRange = entryFieldMask.split(this.DATE_RANGE_SEPARATOR);
      return {
        startDatePeriod: {
          startDate: moment(dateRange[0]),
          endDate: moment(dateRange[1]),
        },
      };
    }
    return undefined;
  }
}
